__turbopack_context__.v({
  "blok-big-title": "VariantPicker-module__XgzBKW__blok-big-title",
  "blok-subtitle": "VariantPicker-module__XgzBKW__blok-subtitle",
  "blok-title": "VariantPicker-module__XgzBKW__blok-title",
  "color": "VariantPicker-module__XgzBKW__color",
  "colors": "VariantPicker-module__XgzBKW__colors",
  "container": "VariantPicker-module__XgzBKW__container",
  "custom": "VariantPicker-module__XgzBKW__custom",
  "custom-border": "VariantPicker-module__XgzBKW__custom-border",
  "custom-plus": "VariantPicker-module__XgzBKW__custom-plus",
  "inactive": "VariantPicker-module__XgzBKW__inactive",
  "label-container": "VariantPicker-module__XgzBKW__label-container",
  "name-container": "VariantPicker-module__XgzBKW__name-container",
  "selected": "VariantPicker-module__XgzBKW__selected",
  "size": "VariantPicker-module__XgzBKW__size",
  "size-guide": "VariantPicker-module__XgzBKW__size-guide",
  "sizes": "VariantPicker-module__XgzBKW__sizes",
  "soldout-tag": "VariantPicker-module__XgzBKW__soldout-tag",
  "variant-name": "VariantPicker-module__XgzBKW__variant-name",
  "yarn-change": "VariantPicker-module__XgzBKW__yarn-change",
  "yarn-detail": "VariantPicker-module__XgzBKW__yarn-detail",
  "yarn-details": "VariantPicker-module__XgzBKW__yarn-details",
  "yarn-lineprice": "VariantPicker-module__XgzBKW__yarn-lineprice",
  "yarn-list": "VariantPicker-module__XgzBKW__yarn-list",
  "yarn-name": "VariantPicker-module__XgzBKW__yarn-name",
  "yarn-option": "VariantPicker-module__XgzBKW__yarn-option",
  "yarn-placeholder": "VariantPicker-module__XgzBKW__yarn-placeholder",
  "yarn-summary": "VariantPicker-module__XgzBKW__yarn-summary",
  "yarnCallout": "VariantPicker-module__XgzBKW__yarnCallout",
});
